import { render } from "./PropertySingle.vue?vue&type=template&id=2ee35bce&scoped=true"
import script from "./PropertySingle.vue?vue&type=script&lang=js"
export * from "./PropertySingle.vue?vue&type=script&lang=js"

import "./PropertySingle.vue?vue&type=style&index=0&id=2ee35bce&scoped=true&lang=css"

import exportComponent from "/var/www/html/webmobtuts/realestateapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee35bce"]])

export default __exports__